import mark from "../../../../public/garden/favicon.svg";
import "./wordmark.css";

/** Shared brand contents; the caller owns the link and its destination. */
export function GardenWordmark() {
  return (
    <>
      <img
        className="garden-brand-icon"
        src={
          import.meta.env.VITE_EMBEDDED_WORKSPACE === "true"
            ? mark
            : "/garden/favicon.svg"
        }
        alt=""
      />
      <span className="garden-brand-name">Garden</span>
      <small>by Sauna</small>
    </>
  );
}
